import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { selectPreferenceValue } from '@store/user/user.selector';
import { PreferenceCode } from '@store/user/user.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { select, Store } from '@ngrx/store';
import { AppState } from '@root/app-state.module';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export enum SearchMaximumResultsAction {
  EXPORT_RESULTS = 'EXPORT_RESULTS',
  CREATE_LABELS = 'CREATE_LABELS',
  SHOW_RESULTS = 'SHOW_RESULTS',
  REFINE_SEARCH = 'REFINE_SEARCH'
}

@UntilDestroy()
@Component({
  selector: 'rlst-search-maximum-results',
  templateUrl: './search-maximum-results.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchMaximumResultsComponent implements OnInit {

  public readonly SearchMaximumResultsAction: typeof SearchMaximumResultsAction = SearchMaximumResultsAction;
  public isLabelPreferenceEnabled$: Observable<boolean>;

  constructor(
    private readonly store$: Store<AppState>,
    private readonly dialogRef: MatDialogRef<SearchMaximumResultsComponent, SearchMaximumResultsAction>,
    @Inject(MAT_DIALOG_DATA) public data: { maxRecordsToSearch: number }) {
  }

  ngOnInit() {
    this.isLabelPreferenceEnabled$ = this.store$
      .pipe(
        select(selectPreferenceValue(PreferenceCode.PG_RL_SHOW_LABEL, PreferenceCode.PREF_RL_SHOW_LABEL)),
        map((value) => {
          if (value === 'N') {
            return false;
          } else {
            return true;
          }
        }),
        untilDestroyed(this)
      );
  }

  public close(action: SearchMaximumResultsAction): void {
    this.dialogRef.close(action);
  }

}
